export default __webpack_public_path__ + "static/media/fitbit_logo.bdd02eff.png";